var _mask, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSms(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "icon-sms_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 21c-5.523 0-10-4.03-10-9s4.477-9 10-9 10 4.03 10 9c0 1.865-.63 3.597-1.71 5.034l.481 3.364a1 1 0 01-1.306 1.09l-3.58-1.193A10.933 10.933 0 0112 21z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.29 17.034l-1.98.283-.117-.821.498-.663 1.6 1.201zm.481 3.364l-1.98.283 1.98-.283zm-1.306 1.09l.633-1.897-.633 1.897zm-3.58-1.193l-.71-1.87.667-.253.676.226-.632 1.897zM4 12c0 3.673 3.378 7 8 7v4C5.576 23 0 18.268 0 12h4zm8-7c-4.622 0-8 3.327-8 7H0C0 5.732 5.576 1 12 1v4zm8 7c0-3.673-3.378-7-8-7V1c6.424 0 12 4.732 12 11h-4zm-1.309 3.833C19.53 14.718 20 13.402 20 12h4c0 2.328-.79 4.477-2.11 6.235l-3.199-2.402zm.1 4.848l-.48-3.364 3.96-.566.48 3.364-3.96.566zm1.306-1.09a1 1 0 00-1.306 1.09l3.96-.566c.316 2.208-1.803 3.976-3.919 3.27l1.265-3.794zm-3.579-1.193l3.58 1.193-1.265 3.795-3.58-1.193 1.265-3.795zM12 19a8.933 8.933 0 003.175-.574l1.421 3.739c-1.42.54-2.974.835-4.596.835v-4z",
    mask: "url(#icon-sms_svg__a)"
  })));
}
export default SvgIconSms;